export default "__VITE_ASSET__v1VI0qTM__"